import { useParams } from 'react-router-dom';
import { CloseCircleOutlined, PlayCircleTwoTone } from '@ant-design/icons';
import { Button, Form, Popconfirm } from 'antd';

import { IOfferStore, offerStore } from 'containers/Offers/Offer/store';

import { usePutRequest } from 'hooks';

import { OfferDetails } from 'codegen';
import { RecursiveRequired } from 'types';

import { handlePublishOfferRequest, handleSuccessPutOfferDetails } from './publishOfferBtnHelpers';

const { useFormInstance } = Form;

export const PublishOfferBtn = ({ disabled }: { disabled: boolean }) => {
  const status = offerStore((state) => state.status);
  const identities = offerStore((state) => state.identities);
  const selectItems = offerStore((state) => state.selectItems);

  const { offerId } = useParams();

  const form = useFormInstance<RecursiveRequired<IOfferStore['initialValues']>>();

  const [publishOfferDetails, { loading: publishLoading }] = usePutRequest<OfferDetails>({
    url: `/offers/details/${offerId}/publish`,
    options: {
      onSuccess: handleSuccessPutOfferDetails('published'),
    },
  });

  const [unpulishOfferDetails, { loading: unpublishLoading }] = usePutRequest<OfferDetails>({
    url: `/offers/details/${offerId}/unpublish`,
    options: {
      onSuccess: handleSuccessPutOfferDetails('unpublished'),
    },
  });

  const isShowPublishBtn = status === OfferDetails.status.DRAFT && (!selectItems?.length || !!identities?.length);
  const isShowUnpublishBtn = status !== OfferDetails.status.DRAFT && (!selectItems?.length || !!identities?.length);

  if (isShowPublishBtn) {
    return (
      <Popconfirm
        title={(
          <div className='w-[200px]'>
            The offer will become visible for collectors in mobile app. Are you sure you want to publish this offer?
          </div>
        )}
        okText='Publish'
        cancelText='No'
        placement='bottom'
        disabled={form?.isFieldsTouched() || disabled}
        onConfirm={handlePublishOfferRequest(publishOfferDetails)}
      >
        <Button
          loading={publishLoading}
          disabled={form?.isFieldsTouched() || disabled}
          icon={<PlayCircleTwoTone twoToneColor={form?.isFieldsTouched() ? '#b8b8b8' : ''} />}
        >
          Publish Offer
        </Button>
      </Popconfirm>
    );
  }

  if (isShowUnpublishBtn) {
    return (
      <Popconfirm
        title={(
          <div className='w-[200px]'>
            The offer will become NOT visible for collectors in mobile app. Are you sure you want to unpublish this offer?
          </div>
        )}
        okText='Unpublish'
        cancelText='No'
        placement='bottom'
        disabled={form?.isFieldsTouched() || disabled}
        onConfirm={handlePublishOfferRequest(unpulishOfferDetails)}
      >
        <Button
          danger
          loading={unpublishLoading}
          disabled={form?.isFieldsTouched() || disabled}
          icon={<CloseCircleOutlined twoToneColor={form?.isFieldsTouched() ? '#b8b8b8' : ''} />}
        >
          Unpublish Offer
        </Button>
      </Popconfirm>
    );
  }

  return null;
};
